import { Component, ElementRef, ViewChild } from '@angular/core';
import { ConsultationsService } from '../../../../core/services/consultation/consultations.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PatientsService } from '../../../../core/services/patient/patients.service';
import { CommonModule, DatePipe } from '@angular/common';
import { ToastComponent } from '../../../shared/toast/toast.component';
import { CurrentUserService } from '../../../../core/services/user/current-user.service';
import { FullscreenService } from '../../../../core/services/fullscreen.service';
import { StatusUtils } from '../../../../utils/status-utils';
import { CaseStatus } from '../../../../../enums/case-status.enum';
import { BaseChartDirective } from 'ng2-charts';
import { Chart, ChartConfiguration, registerables } from 'chart.js';
import { SurveyService } from '../../../../core/services/survey/survey.service';
import { PatientCaseSurveyDetailsModel } from '../../../../core/models/survey/patient-case-survey-details.model';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { QRCodeModule } from 'angularx-qrcode';
import { MeasurementListModel } from '../../../../core/models/survey/measurement-list.model';
import { QRCodeDetailsModel } from '../../../../core/models/patient/qr-code-details.model';
import { ToastService } from '../../../../core/services/toast.service';
import { DiabetesCaseInformation } from '../../../../core/models/patient/diabet-case-information.model';
import { LifestyleProfile } from '../../../../core/models/patient/lifestyle-profile.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { InsulinAdministrationMethod } from '../../../../../enums/insulin-administration-method.enum';
import { AiReportComponent } from '../../../components/patient-detail/ai-report/ai-report.component';
import { ConsultationReportComponent } from '../../../components/patient-detail/consultation-report/consultation-report.component';
import { ChatComponent } from '../../../components/patient-detail/chat/chat.component';
import { CaseInformationComponent } from '../../../components/patient-detail/case-information/case-information.component';
import { TabsModel } from '../../../../core/models/tabs.model';
import { UserSessionModel } from '../../../../core/models/user/current-user.model';
@Component({
  selector: 'app-patient-detail',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SelectDropDownModule,
    QRCodeModule,
    TranslateModule,
    CaseInformationComponent,
    AiReportComponent,
    ConsultationReportComponent,
    ChatComponent,
  ],
  templateUrl: './patient-detail.component.html',
  styleUrl: './patient-detail.component.scss',
  providers: [DatePipe],
})
export class PatientDetailComponent {
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('modal') modal!: ElementRef;
  @ViewChild(BaseChartDirective) chart!: BaseChartDirective;
  @ViewChild(ConsultationReportComponent)
  consultationReportComponent!: ConsultationReportComponent;
  @ViewChild(AiReportComponent) aiReportComponent!: AiReportComponent;
  @ViewChild(ChatComponent) chatComponent!: ChatComponent;
  chartData!: any;
  chartOptions: ChartConfiguration['options'] = {
    responsive: true,
  };
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private consultationsService: ConsultationsService,
    private patientsService: PatientsService,
    private surveyService: SurveyService,
    private currentUserService: CurrentUserService,
    private fullscreenService: FullscreenService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {
    Chart.register(...registerables);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    this.maxDate = today.toISOString().split('T')[0];
    this.minDate = today.toISOString().split('T')[0];
  }
  tabs: TabsModel[] = [];
  caseStatus = CaseStatus;
  patientId: string = '';
  statusClass: string = '';
  statusText: string = '';
  patientRecordCaseId: string = '';
  consultationTimeline: any[] = [];
  patientDetailHeader = {
    name: '',
    lastName: '',
    gender: '',
    age: null as any,
    patientStatus: 0,
    createdDate: '',
    createdBy: '',
    caseId: '',
    customerName: '',
  };
  consultationTimeLines: any = [];
  timeLineDates: string[] = [];
  selectedIndex: number | null = null;
  caseNo: number = 0;
  patientHeaderInformations: any = [];
  patientCaseSurveyDetails: PatientCaseSurveyDetailsModel[] = [];
  consultationId: string = '';
  messageText: string = '';
  currentUser: UserSessionModel | null = null;
  private tabChangeListener: any;
  ecgFileError: string = '';
  consultationReportError: string = '';
  maxDate: string = '';
  minDate: string = '';
  qrCodeDetails: QRCodeDetailsModel = { url: '' };
  measurements: MeasurementListModel[] = [];
  diabetesCaseInformation: DiabetesCaseInformation;
  lifestyleProfile: LifestyleProfile | null = null;
  activeTabList: string[] = [];

  ngOnInit() {
    this.patientId = this.route.snapshot.paramMap.get('id')!;
    this.currentUser = this.currentUserService.GetSession();
    this.patientsService.setPatientId(this.patientId);
    this.consultationTimeLineByPatientId(this.patientId);
  }

  ngAfterViewInit() {
    this.fullscreenService.initializeFullscreenButtons();
    this.tabs = [
      {
        id: 'caseInformation',
        name: `${this.translateService.instant('case')} ${
          this.caseNo + 1
        } ${this.translateService.instant('information')}`,
        href: '#caseInformation',
        active: true,
        display: 'block',
      },
      {
        id: 'aiReport',
        name: 'aiReport',
        href: '#aiReport',
        active: false,
        display:
          this.patientHeaderInformations?.patientStatus >
          this.caseStatus.WaitingConsultation
            ? 'block'
            : 'none',
      },
      {
        id: 'consultationReport',
        name: 'consultationReport',
        href: '#consultationReport',
        active: false,
        display:
          this.patientHeaderInformations?.patientStatus >
          this.caseStatus.WaitingConsultation
            ? 'block'
            : 'none',
      },
      {
        id: 'chatWithInternist',
        name: 'chatWithInternist',
        href: '#chatWithInternist',
        active: false,
        display:
          this.patientHeaderInformations?.patientStatus >
          this.caseStatus.WaitingConsultation
            ? 'block'
            : 'none',
      },
    ];
  }

  ngOnDestroy() {
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
      tab.removeEventListener('shown.bs.tab', this.tabChangeListener);
    });
  }

  selectTab(tab: TabsModel) {
    this.activeTabList.push(tab.id);
  }

  consultationTimeLineByPatientId(id: string) {
    if (id) {
      this.patientsService.consultationTimeLineByPatientId(id).subscribe({
        next: (res) => {
          if (res) {
            res.forEach((item: any) => {
              item.createdDate = item.createdDate.substring(0, 10);
            });

            this.consultationId = res[0]?.patientRecordCaseId;
            this.consultationTimeLines = res;
            this.timeLineDates = this.generateTimeLineDates();
            this.getPatientInformations(this.consultationId);
            this.getMeasurement(this.consultationId);
            this.getPatientRecordCaseDetail(this.consultationId);
            this.selectedIndex = 0;
          }
        },
      });
    }
  }

  selectItem(index: number, selectItem: any): void {
    this.selectedIndex = index;
    this.caseNo = index;
    this.consultationId = selectItem.patientRecordCaseId;
    this.getPatientInformations(selectItem.patientRecordCaseId);
    this.getPatientRecordCaseDetail(selectItem.patientRecordCaseId);
    if (this.activeTabList.includes('aiReport')) {
      this.aiReportComponent.getAIReport(selectItem.patientRecordCaseId);
    }
    if (this.activeTabList.includes('consultationReport')) {
      this.consultationReportComponent.getConsultationReport(
        selectItem.patientRecordCaseId
      );
    }
    if (this.activeTabList.includes('chatWithInternist')) {
      this.chatComponent.getChatList(selectItem.patientRecordCaseId);
    }
  }

  generateTimeLineDates(): string[] {
    const today = new Date();
    const fiveDaysAgo = new Date(today);
    fiveDaysAgo.setDate(today.getDate() - 5);

    const dateArray = [];
    for (let i = 5; i >= 1; i--) {
      const pastDate = new Date(today);
      pastDate.setDate(today.getDate() - i);
      dateArray.push(pastDate.toISOString().split('T')[0]);
    }

    dateArray.push(today.toISOString().split('T')[0]);

    for (let i = 1; i <= 5; i++) {
      const futureDate = new Date(today);
      futureDate.setDate(today.getDate() + i);
      dateArray.push(futureDate.toISOString().split('T')[0]);
    }

    return dateArray;
  }
  calculateWidth(timeLine: any): number {
    const start = new Date(timeLine.createdDate);
    start.setHours(0, 0, 0, 0);

    let today = new Date();
    if (timeLine.reportDate) {
      today = new Date(timeLine.reportDate);
    }
    today.setHours(0, 0, 0, 0);
    const fiveDaysAgo = new Date();
    fiveDaysAgo.setHours(0, 0, 0, 0);
    fiveDaysAgo.setDate(today.getDate() - 5);

    const startAdjusted = start < fiveDaysAgo ? fiveDaysAgo : start;
    const totalDays = this.timeLineDates.length - 1;
    const diffTime = today.getTime() - startAdjusted.getTime();
    let widthPercentage = (diffTime / (totalDays * 24 * 60 * 60 * 1000)) * 100;
    if (start > fiveDaysAgo) {
      widthPercentage = widthPercentage + 5;
    } else {
      if (widthPercentage < 25) widthPercentage = widthPercentage + 10;
    }
    if (widthPercentage <= 5) widthPercentage = 5;
    return Math.min(widthPercentage, 100);
  }
  calculateLeftPosition(startDate: string): number {
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    const firstDate = new Date(this.timeLineDates[0]);
    const fiveDaysAgo = new Date();
    fiveDaysAgo.setHours(0, 0, 0, 0);
    fiveDaysAgo.setDate(new Date().getDate() - 5);

    const startAdjusted = start < fiveDaysAgo ? fiveDaysAgo : start;
    const diffTime = startAdjusted.getTime() - firstDate.getTime();
    const totalDays = this.timeLineDates.length - 1;
    let leftPercentage = (diffTime / (totalDays * 24 * 60 * 60 * 1000)) * 100;
    if (start > fiveDaysAgo) {
      if (leftPercentage > 25 && leftPercentage < 40)
        leftPercentage = leftPercentage + 2;
      else leftPercentage = leftPercentage + 2;
    } else {
      leftPercentage = leftPercentage + 7;
    }

    if (leftPercentage > 50) leftPercentage = 50;

    return Math.max(leftPercentage, 0);
  }

  getPatientInformations(id: string) {
    this.consultationsService
      .consultationDetailByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          if (res) {
            this.patientHeaderInformations = res;
            this.statusClass = StatusUtils.getCaseStatusClass(
              res?.patientStatus
            );
            this.statusText = StatusUtils.getCaseStatusText(res?.patientStatus);
          }
        },
      });
  }

  getPatientRecordCaseDetail(id: string) {
    if (id) {
      this.patientsService.getPatientRecordCaseDetail(id).subscribe({
        next: (res) => {
          this.diabetesCaseInformation = res?.diabetesCaseInformation;
          this.lifestyleProfile = res?.lifestyleProfile ?? null;
        },
      });
    }
  }

  selectCase(timeLine: any, event: MouseEvent) {
    event.stopPropagation();
    this.router.navigate(['/patient/add-patient-case-card'], {
      queryParams: { id: timeLine.patientRecordCaseId },
    });
  }

  closeConsultation() {
    const form = {
      patientRecordCaseId: this.consultationId,
      patientStatus: 6,
    };
    this.patientsService
      .closePatientRecordCase(this.consultationId, form)
      .subscribe({
        next: () => {
          this.toastService.showToast(
            this.translateService.instant(
              'closingConsultationProcessCompletedSuccessfully'
            ),
            'success'
          );

          setTimeout(() => {
            this.router.navigate(['/patient/list']);
          }, 2000);
        },
      });
  }

  getMeasurement(id: string): void {
    this.surveyService.measurement(id).subscribe({
      next: (res) => {
        this.measurements = res;
        const measureValues = res?.map((item: any) => item.value);
        const measureDates = res?.map((item: any) =>
          new Date(item.measuredDate).toLocaleDateString()
        );
        const dateToBeMeasuredValues = res?.map(
          (item: any) => item.dateToBeMeasured
        );

        this.chartData = {
          labels: measureDates,
          datasets: [
            {
              label: this.translateService.instant('measurements'),
              data: measureValues,
              borderColor: 'rgba(255, 99, 132, 1)',
              backgroundColor: 'rgba(255, 99, 132, 0.2)',
              fill: false,
              tension: 0.4,
              type: 'line',
              dateToBeMeasured:
                dateToBeMeasuredValues?.length > 0
                  ? dateToBeMeasuredValues
                  : [],
            },
          ],
        };

        this.chartOptions = {
          responsive: true,
          scales: {
            x: {
              title: {
                display: true,
                text: this.translateService.instant('dates'),
              },
              beginAtZero: true,
            },
            y: {
              title: {
                display: true,
                text: this.translateService.instant('values'),
              },
              beginAtZero: true,
              ticks: {
                stepSize: 0.2,
              },
            },
          },
        };
      },
    });
  }

  getQrCode(): void {
    this.patientsService.qrCodeForPatientDetail(this.consultationId).subscribe({
      next: (res) => {
        const blob = new Blob([res], { type: 'image/png' });
        const url = URL.createObjectURL(blob);
        this.qrCodeDetails = { url: url };
      },
    });
  }

  checkYesOrNo(value: boolean): string {
    return value
      ? this.translateService.instant('yes')
      : this.translateService.instant('no');
  }

  checkMedicationType(value: any): string {
    return value
      ? this.translateService.instant('yes')
      : this.translateService.instant('no');
  }

  checkInsulinAdministrationMethod(value: any): string {
    if (value === InsulinAdministrationMethod.INJECTION) {
      return this.translateService.instant('injection');
    } else if (value === InsulinAdministrationMethod.PUMP) {
      return this.translateService.instant('pump');
    }
    return '-';
  }

  checkTimePeriod(value: number): string {
    if (value === 1) {
      return this.translateService.instant('morning');
    } else if (value === 2) {
      return this.translateService.instant('noon');
    } else if (value === 3) {
      return this.translateService.instant('evening');
    }
    return '-';
  }

  displayDiabetesCaseInformation(): string {
    const chronicConditions = this.diabetesCaseInformation?.chronicCondition;
    const trueConditions = Object.entries(chronicConditions)
      .filter(([key, value]) => value)
      .map(([key]) =>
        this.translateService.instant('otherImportantChronicDiseases.' + key)
      )
      .join(', ');
    return trueConditions.length > 0 ? trueConditions : '-';
  }
}
